var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white",
    fillOpacity: 0.26
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0008,
    cy: 11.9998,
    r: 7.2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4557 11.1357H12.8637V8.54369C12.8637 8.31454 12.7727 8.09478 12.6106 7.93275C12.4486 7.77072 12.2288 7.67969 11.9997 7.67969C11.7705 7.67969 11.5508 7.77072 11.3887 7.93275C11.2267 8.09478 11.1357 8.31454 11.1357 8.54369V11.1357H8.54369C8.31454 11.1357 8.09478 11.2267 7.93275 11.3887C7.77072 11.5508 7.67969 11.7705 7.67969 11.9997C7.67969 12.2288 7.77072 12.4486 7.93275 12.6106C8.09478 12.7727 8.31454 12.8637 8.54369 12.8637H11.1357V15.4557C11.1357 15.6848 11.2267 15.9046 11.3887 16.0666C11.5508 16.2287 11.7705 16.3197 11.9997 16.3197C12.2288 16.3197 12.4486 16.2287 12.6106 16.0666C12.7727 15.9046 12.8637 15.6848 12.8637 15.4557V12.8637H15.4557C15.6848 12.8637 15.9046 12.7727 16.0666 12.6106C16.2287 12.4486 16.3197 12.2288 16.3197 11.9997C16.3197 11.7705 16.2287 11.5508 16.0666 11.3887C15.9046 11.2267 15.6848 11.1357 15.4557 11.1357Z",
    fill: "#CFA809"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.9bc87935efae52b9c095f75135df61e2.svg";
export { ForwardRef as ReactComponent };